import ConfigManager from '@/config/ConfigManager.js';
import BzbsApi from '@/core/Http/BzbsApi.js';
import CampaignModel from '../model/CampaignModel.js';
import { map } from 'rxjs/operators';

/**
 * @method apiGetCampaign
 * @method apiGetCampaignDetail
 * @method apiSaveCampaignRating
 * @method apiAddFavourite
 * @method apiRemoveFavourite
 */
export default {

    /**
     * @param {String} token
     * @param {Object} objListConfig (Require) CampaignListConfigModel - /core/Campaign/model/CampaignConfigModel.js
     * @param {Object} objListFilterConfig (Optional) CampaignListFilterConfigModel - /core/Campaign/model/CampaignConfigModel.js
     */
    apiGetCampaign: function (token, objListConfig, objListFilterConfig) { 
        var params = objListConfig.getParams();
        if (objListFilterConfig != null) {
            var filter = objListFilterConfig.getParams();
            params = {...params , ...filter};
        }
        const url = ConfigManager.getApiUrl() + "/campaign";
        return BzbsApi.connectBzbsGet(url, token, params)
            .pipe(map((res) => {
                var arrCampaign = [];
                for (var i of res.data) {
                    var objCampaign = new CampaignModel(i);
                    arrCampaign.push(objCampaign);
                }

                return arrCampaign;
            }));
    },

    /**
     * @param {String} token (Require)
     * @param {Object} objDetailConfig (Require) CampaignConfigModel - /core/Campaign/model/CampaignConfigModel.js
     */
    apiGetCampaignDetail: function (token, objDetailConfig) {
        var params = objDetailConfig.getParams();

        const url = ConfigManager.getApiUrl() + `/campaign/${objDetailConfig.strId}`;
        return BzbsApi.connectBzbsGet(url, token, params)
            .pipe(map((res) => {
                var campaign = new CampaignModel(res.data);
                return campaign;
            }));
    },

    /**
     * @param {string} token
     * @param {string|number} campaignId
     * @param {number} rating
     * @param {string} message (optional)
     */
    apiSaveCampaignRating: function(token, campaignId, rating, message) {
        var params = {
            rating: rating,
        };

        if (message) {
            params.message = message;
        }
        const url = ConfigManager.getApiUrl() + `/campaign/${campaignId}/buzz`;
        return BzbsApi.connectBzbsPost(url, token, params).pipe(map((res) => {
            return res.data;
        }));
    },

    /**
     * @param {string} token
     * @param {string} campaignId
     */
     apiAddFavourite: function(token, campaignId) {
        const url = ConfigManager.getApiUrl() + `/campaign/${campaignId}/favourite`;
        return BzbsApi.connectBzbsPost(url, token, null).pipe(map((res) => {
            return res.data;
        }));
    },

    /**
     * @param {string} token
     * @param {string} campaignId
     */
    apiRemoveFavourite: function(token, campaignId) {
        const url = ConfigManager.getApiUrl() + `/campaign/${campaignId}/favourite`;
        return BzbsApi.connectBzbsDelete(url, token, null).pipe(map((res) => {
            return res.data;
        }));
    },


}
